import { FriendsState, FriendsResponse } from "./types";

import { fetchUserRequestingFriends } from "./services";

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: FriendsState = {
    friends: [],
    loading: false,
    error: null,
};

const userRequestingFriendsSlice = createSlice({
    name: 'userRequestingFriends',
    initialState,
    reducers: {
        resetUserRequestingFriends: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserRequestingFriends.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserRequestingFriends.fulfilled, (state, action: PayloadAction<FriendsResponse>) => {
                state.loading = false;
                state.friends = action.payload.response.collection;
            })
            .addCase(fetchUserRequestingFriends.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string || 'Failed to fetch friends';
            });
    },
});

export const userRequestingFriendsReducer = userRequestingFriendsSlice.reducer;
export const { resetUserRequestingFriends } = userRequestingFriendsSlice.actions;
